var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"root",staticClass:"preview",attrs:{"aria-hidden":"true"}},[_c('div',{ref:"frame",staticClass:"preview__frame"})])
}
var staticRenderFns = []

export { render, staticRenderFns }